import { createSlice } from '@reduxjs/toolkit'
export const namespace = 'fee'

const initialState = {
  loading: true,
  error: null,
  data: []
}

export const slice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    getFee: (state) => ({
      ...state
    }),
    getSuccess: (state, action) => ({
      ...state,
      error: null,
      data: action.payload,
      loading: false
    }),
    getError: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
      data: null
    })
  }
})

// Action creators are generated for each case reducer function
export const { getFee, getSuccess, getError } = slice.actions
// Selector
export const feeSelector = (state) => state[namespace]
// Reducer
export const { reducer } = slice

export { rootSagas as saga } from './saga'
